import { Stack, Tooltip } from '@mui/material';

import { Icon } from '@/components/shared/icon';

const ToggleButtons = <T,>({
  items,
  value,
  onChange,
}: {
  items: { title: string; iconClass: string; value: T }[];
  value?: T;
  onChange?: (value: T) => void;
}) => {
  return (
    <Stack
      direction='row'
      sx={{
        position: 'absolute',
        backgroundColor: 'var(--mui-palette-common-white)',
        boxShadow: '0px 10px 30px 0px rgba(0, 0, 0, 0.10)',
        borderRadius: '4px',
        gap: '10px',
        padding: '8px',
        display: 'flex',
        right: '48px',
        top: '24px',
      }}
    >
      {items.map((item, i) => {
        const isActive = value === item.value;
        return (
          <Tooltip
            key={i}
            title={item.title}
            PopperProps={{ disablePortal: true }}
          >
            <Icon
              sx={{
                backgroundColor: isActive
                  ? 'var(--mui-palette-background-black1)'
                  : 'white',
                '&:hover': {
                  backgroundColor: 'var(--mui-palette-background-black1)',
                  '& i': { color: 'white' },
                },
                '& i': {
                  color: isActive
                    ? 'white'
                    : 'var(--mui-palette-background-black1)',
                },
              }}
              iconClass={item.iconClass}
              isActive={value === item.value}
              onClick={() => onChange?.(item.value)}
            />
          </Tooltip>
        );
      })}
    </Stack>
  );
};

export default ToggleButtons;
